import type {ProjectRole} from '@/types/api';

export function canEditContent(role?: ProjectRole | null): boolean {
	return role === 'OWNER' || role === 'ADMIN' || role === 'EDITOR';
}

export function canShare(role?: ProjectRole | null): boolean {
	return role === 'OWNER' || role === 'ADMIN';
}

export function canManageProject(role?: ProjectRole | null): boolean {
	return role === 'OWNER' || role === 'ADMIN';
}

export function canDeleteProject(role?: ProjectRole | null): boolean {
	return role === 'OWNER';
}

export function roleLabel(role?: ProjectRole | null): string {
	if (role === 'OWNER') return 'Владелец';
	if (role === 'ADMIN') return 'Администратор';
	if (role === 'EDITOR') return 'Редактирование';
	if (role === 'VIEWER') return 'Просмотр';
	return 'Нет доступа';
}
